// import React, { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  // const [email, setEmail] = useState("");

  // const handleSubscribe = (e) => {
  //   e.preventDefault();
  //   console.log("Subscribed Email:", email);
  //   setEmail("");
  // };

  // const services = [

  //   { name: "Offshore Offices", link: "/offshoreoffices" },
  //   { name: "Business Intelligence Services", link: "/business-intelligence" },
  //   { name: "UI/UX Design Services", link: "/ui-ux" },
  //   { name: "THIRD PARTY API INTEGRATION", link: "/third-party-api-integration" },
  //   { name: "Mobile Application Development", link: "/mobile-app-development" },
  //   { name: "Web Development Services", link: "/web-development" },
  // ];

  const information = [
    { name: "Company Profile", link: "/about-us" },
    { name: "Our People & Culture", link: "/our-people-culture" },
    { name: "Why Choose Us", link: "/why-choose-us" },
    { name: "Mission & Values", link: "/about-us" },
    { name: "Machine Test", link: "/machine-test" },
  ];

  return (
   
    <footer id="footer" className="footer-section">
      <div className="container">
        <div className="footer-content pt-2 pb-2 pt-md-5 pb-md-5">
          <div className="row">
            {/* Left Section - Logo & Social Icons */}
            <div className="col-lg-4 col-md-6 col-sm-12 mb-50">
              <div className="footer-widget px-md-3">
                <div className="footer-logo">
                  <Link to="/#" className="logo d-flex align-items-center">
                    <img src="/assets/images/logo.png" alt="logo" />
                  </Link>
                </div>

                <p>BBSoft is a top Canadian Software Development company, driving innovation with cutting edge AI solutions powered by SPADEZ’s expert support.</p>
                

               <div className="footer-social-icon">
                  <span>Social Media</span>
                  <a href="mailto:bobby.buttar@gmail.com" rel="noopener noreferrer">
                    <i className="fa-solid fa-envelope"></i>
                  </a>
                  <a href="https://www.facebook.com/BB SoftGroup/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook"></i>
                  </a>
                  <a href="https://in.linkedin.com/company/spadez-solutions-priv-limited" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-linkedin"></i>
                  </a>
                  <a href="https://www.upwork.com/agencies/425300268729659393/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-upwork"></i>
                  </a>
                </div>
                
                
              </div>
            </div>

          

            {/* Information Section */}
            <div className="col-lg-2 col-md-6 col-sm-12 footer-column">
              <div className="service-widget footer-widget">
                <h3>Information</h3>
                <ul className="list">
                  {information.map((item, index) => (
                    <li key={index}>
                      <Link to={item.link}>{item.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                <div className="contact-widget footer-widget">
                  <h3>Contacts</h3>
                  <address>
                    <i className="fa-solid fa-location-dot"></i>Mandeep Singh Buttar  - 11644 64B Ave Delta B.C. Canada - V4E 2C9
                  </address>
                  <a href="tel:+1-778-954-7118" style={{'color': '#fff'}}>
                    <i className="fa-solid fa-phone"></i>+1-778-954-7118
                  </a>
                   <a href="tel:72272 2501 BC0001" style={{'color': '#fff'}}>
                    <i className="fa-solid fa-phone"></i> 72272 2501 BC0001
                  </a>
                  <a href="mailto:bobby.buttar@gmail.com" style={{'color': '#fff'}}>
                    <i className="fa-solid fa-envelope"></i> bobby.buttar@gmail.com
                  </a>
                  <p style={{'color': '#fff'}}>
                    <span className="me-2 d-inline-block"><b className="text-danger">GST#</b></span>72272 2501 RT0001
                  </p>
                </div>
            </div>

            {/* Services Section */}
            <div className="col-lg-3 col-md-6 col-sm-12 footer-column">
                <div className="contact-widget footer-widget">
                 <h3>Offshore Offices</h3>
                   <address>
                    <i className="fa-solid fa-location-dot"></i>India Office – Spadez Solution - 3rd Floor, Spadez Tower, Sector 71, Mohali, Punjab, India
                  </address>
                  <a href="tel:+91 172 466 4601" style={{'color': '#fff'}}>
                    <i className="fa-solid fa-phone"></i>+91 172 466 4601
                  </a>
                  <a href="mailto:info@spadezgroup.com" style={{'color': '#fff'}}>
                    <i className="fa-solid fa-envelope"></i> info@spadezgroup.com
                  </a>
                  <div className="mt-2">
                    <h5 className="mb-2">Business Hours:</h5>
                    <p className="mb-0"><b className="text-danger">Canada</b>: 9 AM – 5 PM EST</p>
                    <p><b className="text-danger">India</b>: 9 AM – 7 PM IST</p>
                  </div>
              </div>
            </div>

            

          </div>

          {/* Copyright Section */}
          <div className="row">
            <div className="col-xl-12 col-lg-12 text-center">
              <div className="copyright-text">
                <p>
                  &copy; {new Date().getFullYear()}{" "}
                  <Link to="/" target="_blank">
                    <span>BB Soft Solutions Pvt. Ltd.</span>
                  </Link>{" "}
                  All Rights Reserved
                </p>
                </div>
            </div>
          </div>
        </div>
      </div>

      
    </footer>


  );
};

export default Footer;
